/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Checkbox, HFlow, Text, Theme, Tooltip, useTheme, VFlow } from 'bold-ui'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { MCHAT_PERGUNTAS } from '../../mchat/model-mchat'
import { getMChatPerguntaNumber } from '../../mchat/utils-mchat'
import { ConsultaSeguimentoPerguntaSelectListItemStatus } from './ConsultaSeguimentoPerguntaSelectListItemStatus'

interface ConsultaSeguimentoPerguntaSelectListProps {
  listOfPerguntas: MChatPerguntaEnum[]
  disabled?: boolean
  disabledTooltipText?: string
  getListItemHasData: (pergunta: MChatPerguntaEnum) => boolean
}

export function ConsultaSeguimentoPerguntaSelectList(props: Readonly<ConsultaSeguimentoPerguntaSelectListProps>) {
  const { listOfPerguntas, disabled, disabledTooltipText, getListItemHasData } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <VFlow style={styles.list}>
      {listOfPerguntas.map((pergunta: MChatPerguntaEnum) => (
        <HFlow key={pergunta} alignItems='center' justifyContent='space-between' hSpacing={2}>
          <Text>
            {getMChatPerguntaNumber(pergunta)}. “{MCHAT_PERGUNTAS[pergunta]}”
            <Text component='span' fontWeight='bold' color='danger'>
              {' '}
              *
            </Text>
            {getListItemHasData(pergunta) && <ConsultaSeguimentoPerguntaSelectListItemStatus status='INFO' />}
          </Text>
          <Tooltip text={disabled && disabledTooltipText}>
            <div>
              <Checkbox checked disabled={disabled} />
            </div>
          </Tooltip>
        </HFlow>
      ))}
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  list: css`
    & > div {
      border-bottom: 1px solid ${theme.pallete.divider};
      margin: 0;
      padding: 0.25rem 1rem;
      &:last-child {
        border-bottom: 0;
      }
    }
  `,
})
